import { resolveTipoGastoIcone, TIPO_GASTO_ICONES } from './tipo-gasto-icones';

interface TipoGastoIconeSelectProps {
  value?: string | null;
  cor?: string | null;
  onChange: (icone: string | null) => void;
  id?: string;
}

export function TipoGastoIconeSelect({
  value,
  cor,
  onChange,
  id = 'tipo-gasto-icone',
}: TipoGastoIconeSelectProps) {
  const selecionado = TIPO_GASTO_ICONES.find((item) => item.key === value);
  const IconeAtual = resolveTipoGastoIcone(value);
  const corIcone = cor || undefined;

  return (
    <div className="dropdown">
      <button
        id={id}
        type="button"
        className="btn btn-outline-secondary dropdown-toggle d-inline-flex align-items-center gap-2"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        aria-haspopup="listbox"
      >
        {IconeAtual ? (
          <IconeAtual size={16} aria-hidden style={{ color: corIcone }} />
        ) : (
          <span className="text-muted">—</span>
        )}
        <span>{selecionado?.label ?? 'Nenhum'}</span>
      </button>
      <ul className="dropdown-menu" style={{ maxHeight: 280, overflowY: 'auto' }} role="listbox">
        <li>
          <button
            type="button"
            className={`dropdown-item d-flex align-items-center gap-2 ${!value ? 'active' : ''}`}
            onClick={() => onChange(null)}
          >
            <span className="text-muted" style={{ width: 16, textAlign: 'center' }}>—</span>
            Nenhum
          </button>
        </li>
        {TIPO_GASTO_ICONES.map(({ key, label, Icon }) => (
          <li key={key}>
            <button
              type="button"
              className={`dropdown-item d-flex align-items-center gap-2 ${value === key ? 'active' : ''}`}
              onClick={() => onChange(key)}
            >
              <Icon size={16} aria-hidden style={{ color: corIcone }} />
              {label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
